import script from "./EditorToolbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditorToolbar.vue?vue&type=script&setup=true&lang=ts"

import "./EditorToolbar.vue?vue&type=style&index=0&id=ee2fca90&lang=scss"

const __exports__ = script;

export default __exports__